import { LegacyDateValue } from '@bonhams1793/bonhams-typescript'
import { format, toZonedTime } from 'date-fns-tz'

export function StartingFrom({ hammerTime }: StartingFromProps) {
  const date = toZonedTime(hammerTime.datetime, hammerTime.timezone.iana)
  const timezoneFormat = `'${hammerTime.timezone.abbreviation}'`

  return (
    <div>
      {format(date, `d LLLL yyyy, HH:mm ${timezoneFormat}`, {
        timeZone: hammerTime.timezone.iana,
      })}
    </div>
  )
}

export interface StartingFromProps {
  hammerTime: LegacyDateValue
}
